import { PaginatedRequest, PaginatedResponse, SmartOptionResource } from '../types';
import request from './request';

export default {
    // @Todo: I don't like the way of setting hidden private properties, it would be cleaner if that would work like a constructor function => const api = createApiClient(url, token); Singletons are not idiomatic in JS.
    setApiUrl: request.setApiUrl,
    setSessionToken: request.setSessionToken,
    setGlobalErrorHandler: request.setGlobalErrorHandler,

    session: {
        signIn: (email, password) => request.post('sessions', { email, password }),
    },

    account: {
        getAccount: (id) => request.get('accounts/' + id.toString()),
        updateAccount: (id, data) => request.put(`accounts/${id}`, data),
        setRole: (id, role) => request.put(`accounts/${id}/role`, { role }),
        setPassword: (id, password, new_password) =>
            request.put(`accounts/${id}/password`, { password, new_password }),
    },

    passwords: {
        generate: () => request.post('passwords'),
        reset: (email) => request.post('passwords/' + email),
    },

    getMetrics: () => request.get('metrics'),
    getMeasures: () => request.get('measures'),
    getCauses: (search, page, per_page) => request.get('causes', { search, page, per_page }),
    getAgeGroups: () => request.get('age-groups'),
    getGenders: () => request.get('genders'),
    getBmiCategories: () => request.get('bmi-categories'),
    getLocationTypes: () => request.get('location-types'),
    // { type_id }
    getLocations: (search) => request.get('locations', search),
    getLocationsByType: (type_id) => request.get('locations', { type_id }),
    getLocationsBorders: () => request.get('locations-borders'),

    settings: {
        getAllSmartOptions: (
            paginationParams: PaginatedRequest<SmartOptionResource>
        ): Promise<PaginatedResponse<SmartOptionResource>> =>
            request.get('smart-options', paginationParams),
        getSmartOptions: (
            paginationParams: PaginatedRequest<SmartOptionResource>
        ): Promise<PaginatedResponse<SmartOptionResource>> =>
            request.get('smart-options', paginationParams),
        createSmartOption: (resource: Partial<SmartOptionResource>): Promise<SmartOptionResource> =>
            request.post('smart-options', resource),
        updateSmartOption: (resource: Partial<SmartOptionResource>): Promise<SmartOptionResource> =>
            request.put(`smart-options/${resource.id}`, resource),
        deleteSmartOption: (id: number): Promise<boolean> => request.delete(`smart-options/${id}`),
    },

    emailConfirmation: {
        delete: ({ token }) => request.delete(`email-confirmation/${token}`),
        resend: (email) => request.post(`email-confirmation`, { email }),
    },
};

export * from '../services/api/survey';
